import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import { type UserData, type OrganizationData } from '../../types'
import { authApi } from '../api/authApi'

export interface AuthState {
  user: UserData | null
  organization: OrganizationData | null
  token: string | null
}

const initialState: AuthState = {
  user: null,
  organization: null,
  token: null
}

export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setUser: (state, action: PayloadAction<UserData>) => {
      state.user = action.payload
    },
    setOrganization: (state, action: PayloadAction<OrganizationData>) => {
      state.organization = action.payload
    },
    setToken: (state, action: PayloadAction<string>) => {
      state.token = action.payload
    }
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      authApi.endpoints.loginUser.matchFulfilled,
      (state, { payload }) => {
        state.user = payload.user
        state.organization = payload.organization
        state.token = payload.token
      }
    )
  }
})

// Action creators are generated for each case reducer function
export const { setUser, setOrganization, setToken } = authSlice.actions

export default authSlice.reducer
